import { ptBR } from 'date-fns/locale';

export default {
  'durability-language': ptBR,
  'hello': 'Olá, {username}.',
  'comfort': 'Conforto',
  'comfortable': 'Confortável',
  'intermediary': 'Intermediário',
  'critical': 'Crítico',
  'alert': 'Alerta',
  'no_data': 'Sem Dados',
  'lethal': 'Letal',
  'aviaries': 'Aviários',
  'aviary': 'Aviário',
  'loading_properties': 'Carregando propriedades',
  'none_found': 'Nenhuma propriedade foi encontrada',
  'empty_batch': 'Vazio Sanitário',
  'pre_lodged': 'Pré-alojamento',
  'lodged': 'Alojado',
  'slaughter': 'Abate',
  'storage': 'Armazenamento',
  'simulation': 'Simulação',
  'target_weight': 'Peso Alvo',
  'target_value': 'Ração Necessária',
  'entry_weight': 'Peso de Chegada',
  'weekly_weight_projection': 'Projeção de Peso por Idade',
  'leave_weight': 'Peso de Saída',
  'leave_age': 'Idade de Saída',
  'filtros': 'Filtros',
  'aviaries_page': 'Aviários por Página',
  'rations_page': 'Rações por Página',
  'stage': 'Fase',
  'conversionFactor': 'Fator de Conversão',
  'bed_temperature': 'Temperatura da Cama',
  'water_temperature': 'Temperatura da Água',
  'ambient-humidity': 'Umidade Ambiente',
  'ambient-temperature': 'Temperatura Ambiente',
  'humidity-ambient-temperature': 'Temperatura e Umidade Ambiente',
  'shed': 'Galpão',
  'ambience': 'Ambiência',
  'ambient': 'Ambiente',
  'humidity': 'Umidade',
  'message': 'Mensagem',
  'alerts': 'Alertas',
  'creation_date': 'Data de Criação',
  'dateTime': 'Data e Hora',
  'qty24h': 'Últimas 24h',
  'type': 'Tipo',
  'subtype': 'Subtipo',
  'lineage': 'Linhagem',
  'sex': 'Sexo',
  'age': 'Idade',
  'real_age': 'Idade da Ave',
  'batch_age': 'Idade do Lote',
  'weight': 'Peso',
  'dwg': 'G.P.D',
  'alerts/recent': 'Alertas',
  'alerts/history': 'Histórico de Alertas',
  'recent': 'Recentes',
  'uniformity': 'Uniformidade',
  'performance': 'Desempenho',
  'producer': 'Produtor(a)',
  'city': 'Cidade',
  'greater_than': 'Maior que',
  'less_than': 'Menor que',
  'alertTypeQty': 'Tipos',
  'totalQty': 'Quantidade',
  'quantityNf': 'Quantidade NF',
  'quantityTotalDeliveredNf': 'Ração total entregue NF',
  'total_delivered': 'Total entregue',
  'exactly': 'Exatamente',
  'and': 'E',
  'or': 'OU',
  'add': 'Adicionar',
  'remove': 'Remover',
  'identification': 'Identificação',
  'address': 'Endereço',
  'contact': 'Contato',
  'sub_region': 'Sub-região',
  'lodge': 'Alojamento',
  'current_lodge': 'Alojamento Atual',
  'date': 'Data',
  'effective_weight': 'Peso Efetivo',
  'nutrition': 'Nutrição',
  'sanity': 'Sanidade',
  'logout': 'Sair',
  'loading': 'Carregando',
  'en': 'Inglês',
  'es': 'Espanhol',
  'pt-br': 'Português',
  'slaughter_forecast': 'Projeção de Abate',
  'forecast': 'Projeção',
  'close': 'Fechar',
  'last_projected_weight': 'Último Peso Projetado',
  'actions': 'Ações',
  'predicted_weight': 'Peso Projetado',
  'select_a_date': 'Selecione uma Data',
  'days': 'dias',
  'production_days': 'dias em produção',
  'weeks': 'Semanas',
  'production_weeks': 'semanas em produção',
  'production_time': 'Tempo em Produção',
  'prediction': 'Previsão',
  'predictions': 'Previsões',
  'fwu': 'P.P.A',
  'search': 'Buscar',
  'broiler': 'Frango de Corte',
  'broiler_chicken': 'Frango de Corte',
  'matrix': 'Matrizeiro',
  'swine': 'Suíno',
  'swines': 'Suínos',
  'home': 'Início',
  'status': 'Status',
  'silo': 'Silo',
  'ration': 'Ração',
  'rationType': 'Tipo de Ração',
  'capacity': 'Capacidade',
  'free': 'Livre',
  'available': 'Disponível',
  'occupation': 'Ocupação',
  'last_received_time': 'Última Leitura',
  'expected_end_date': 'Prévia de Término',
  'full': 'Cheio',
  'low': 'Baixo',
  'satisfactory': 'Satisfatório',
  'last_ration_delivered': 'Última Ração Entregue',
  'ration_delivered': 'Ração Entregue',
  'consumed': 'Consumido',
  'pre_initial': 'Pré-Inicial',
  'initial': 'Inicial',
  'growth': 'Crescimento',
  'general': 'Geral',
  'male': 'Macho',
  'female': 'Fêmea',
  'production_chicken': 'Aves de Produção',
  'hatch_chicken': 'Aves de Recria',
  'production': 'Produção',
  'hatch': 'Recria',
  'production_type': 'Tipo de Produção',
  'airsacculitis': 'Aerossaculite',
  'contaminated': 'Aves Condenadas',
  'total_delivered_ration': 'Total Entregue',
  'total_consumed': 'Consumo Total',
  'core': 'Núcleo',
  'pcp': 'Planejamento PCP',
  'pcp_filter': 'PCP',
  'dwg_filter': 'GPD',
  'weighing': 'Pesagem',
  'StorageCapacity': 'Capacidade de armazenamento',
  'TotalFeedInTheField': 'Total de ração em campo',
  'TotalFree': 'Total livre',
  'nutritionTotals': 'Totais',
  'total_free': 'Total Disponível',
  'siloRead': 'Leitura Silo',
  'addRationDelivery': 'Cadastrar entrega de ração',
  'last_read': 'Última Leitura',
  'period': 'Período',
  'from': 'De',
  'until': 'Até',
  'predictedEndOfFeed': 'Previsão de Fim de Ração',
  'update': 'Atualizar',
  'groupBy': 'Agrupar por',
  'last_days': 'Últimos dias',
  'between': 'Datas',
  'silo_1': 'Silo 1',
  'silo_2': 'Silo 2',
  'average_consumption': 'Consumo Médio',
  'average_consumption_per_animal': 'Consumo Médio Por Indivíduo',
  'total': 'Total',
  'occupation_history': 'Consumo de Ração',
  'occupation_percent': 'Ocupação (%)',
  'week': 'Semana',
  'age_range': 'Faixa de idade',
  'cancel': 'Cancelar',
  'phase': 'Fase',
  'density': 'Densidade',
  'semi_annual_planning': 'Planejamento Semanal',
  'generateReport': 'Gerar relatório',
  'target_date': 'Data/Hora Alvo',
  'target_age': 'Idade Alvo',
  'need_for_feed': 'Ração necessária',
  'accumulated_consumption': 'Consumo acumulado',
  'weight_prediction': 'Predição de peso',
  'target_weight_prediction': 'Peso Predito',
  'target_weight_company': 'Peso Alvo Companhia',
  'laying-birds': 'Aves Poedeiras',
  'alerts-history': 'Histórico de Alertas',
  'production_birds': 'Aves de Produção',
  'breeding_birds': 'Aves de Recria',
  'Comfortable': 'Confortável',
  'Intermediary': 'Intermediário',
  'Critical': 'Crítico',
  'Lethal': 'Letal',
  'login': 'Entrar',
  'login_title': 'Acesse a sua conta.',
  'username': 'Usuário',
  'username_placeholder': 'Digite seu usuário',
  'password': 'Senha',
  'password_placeholder': 'Digite sua senha',
  'comfort_map': 'Mapa de conforto',
  'amplitude': 'Amplitude',
  'last_reading': 'Última leitura',
  'percent': 'Percentual',
  'property': 'Propriedade',
  'amount_lodge': 'Quantidade Alojada',
  'occupation_history1': 'Histórico de Ocupação',
  'weekAge': 'Idade (semana)',
  'currentLodge': 'Quantidade de animais',
  'weeklyConsumption': 'Média de consumo semanal (Galpão/animal)',
  'Aves poedeiras - recria': 'Recria',
  'Aves poedeiras - produção': 'Postura',
  'endOfRationForecast': 'Previsão de fim de ração',
  'durability': 'Durabilidade',
  'addAlert': 'Adicionar Alerta',
  'real': 'Real',
  'reference': 'Referência',
  'consumptionByAnimal': 'Consumo por Indivíduo',
  'rationConsumptionXIdealConsumption': 'Consumo de ração x consumo ideal',
  'occupation%': 'Ocupação (%)',
  'availableRation': 'Ração Disponível',
  'daily': 'Diário',
  'weekly': 'Semanal',
  'gain': 'Ganho',
  'averageWeight': 'Peso Médio',
  'batch': 'Lote',
  'batch start': 'Início do Lote',
  'last 24h': 'Últimas 24h',
  'first_name': 'Nome',
  'last_name': 'Sobrenome',
  'document': 'Documento (CPF)',
  'ddd_phone': 'DDD',
  'phone': 'Telefone',
  'ddd_cellphone': 'DDD',
  'cellphone': 'Celular',
  'profile': 'Perfil',
  'edit': 'Editar',
  'save': 'Salvar',
  'current_password': 'Senha Atual',
  'new_password': 'Nova Senha',
  'confirm_password': 'Confirme a nova senha',
  'change_password': 'Alterar Senha',
  'userdata_loading_error': 'Erro ao carregar dados do usuário',
  'update_profile_error': 'Erro ao atualizar perfil',
  'password_match_error': 'As senhas não conferem',
  'password_error': 'Erro ao alterar senha',
  'document_error': 'Número de CPF inválido',
  'start': 'Início',
  'end': 'Fim',
  'last-days': 'Últimos dias',
  'group-per-days': 'Agrupar por dias',
  'group-per-weeks': 'Agrupar por semanas',
  'Bateria': 'Bateria',
  'aviaryShed': 'Aviário/Galpão',
  'noData': 'Sem dados disponíveis',
  'propertyOwner': 'Produtor(a)',
  'selectSilo': 'Selecione o silo',
  'no-data': 'Sem Dados',
  'consumption': 'Consumo',
  'division': 'Divisão',
  'breedingType': 'Criação',
  'performance-male-female': 'Desempenho Macho/Fêmea',
  'idealWeightRef': 'Peso Ideal (Referência)',
  'idealWeight': 'Peso Ideal',
  'dailyWeight': 'Peso diário',
  'day': 'Dia',
  'weeklyWeight': 'Peso semanal',
  'histogram': 'Histograma',
  'weightRanges': 'Faixas de Peso',
  'frequency': 'Frequência',
  'sheds': 'Galpões/Lotes',
  'productionType': 'Tipo de Produção',
  'select_sex': 'Selecione o sexo',
  'select_lineage': 'Selecione a linhagem',
  'name': 'Nome',
  'description': 'Descrição',
  'entryWeight': 'Peso de entrada',
  'startingAge': 'Idade de entrada',
  'openingDate': 'Data de abertura',
  'closingDate': 'Data de fechamento',
  'editShed': 'Editar galpão',
  'editBatch': 'Editar lote',
  'addBatch': 'Adicionar lote',
  'amountLodge': 'Quantidade alojada',
  'selectProductionType': 'Selecione o tipo de produção',
  'selectBreedingType': 'Selecione o tipo de criação',
  'effectiveWeight': 'Peso efetivo',
  'closingBeforeOpeningError': 'A data de fechamento não pode ser anterior à data de abertura.',
  'view': 'Visualizar',
  'freeWeight': 'Livre',
  'previous': 'Anterior',
  'next': 'Próximo',
  'page': 'Página',
  'mortalityControl': 'Controle de Mortalidade',
  'mortality': 'Mortalidade',
  'amountEliminated': 'Quantidade Eliminada',
  'amountMortality': 'Quantidade de Mortalidade',
  'dataSaved': 'Dados salvos com sucesso',
  'addMortality': 'Adicionar Mortalidade',
  'openBatch': 'Lote Aberto',
  'closeBatch': 'Fechar Lote',
  'closingBatch': 'Fechamento de lote',
  'amount_lodged': 'Quantidade Alojada',
  'enthalpy': 'Entalpia',
  'rationManagement': 'Gerenciamento de Rações',
  'confirmDelete': 'Confirmar Exclusão',
  'deleteMessage': 'Tem certeza de que deseja excluir este registro?',
  'deliveryWeight': 'Peso da Entrega',
  'plan': 'Plano',
  'link_batch': 'Vincular Lote',
  'plans_page': 'Planos por página',
  'nutritionalWeeklyConsumption': 'Consumo semanal',
  'attention': 'Atenção',
  'ration_edit_confirmation_message': 'Ao editar as informações da ração, todos os dados (consumo, conversão, etc.) dos lotes atuais e anteriores relacionados a essa ração serão recalculados. Tem certeza dessa ação? Escreva o nome da ração para confirmar.',
  'type_here': 'Digite aqui',
  'water_consumption' : 'Consumo de água',
  'water_total_batch' : 'Consumo total do lote',
  'water_per_bird' : 'Consumo total por ave',
  'water_liters_per_bird' : 'L/ave',
  'water_hourly_24h' : 'Consumo por hora — últimas 24 horas',
  'water_load_error' : 'Não foi possível carregar o consumo de água.',
  'water_history' : 'Histórico de consumo de água',
  'water_daily_total' : 'Consumo diário do lote',
  'water_daily_per_bird' : 'Consumo diário por ave',
  'water_weekly_total' : 'Consumo semanal do lote',
  'water_weekly_per_bird' : 'Consumo semanal por ave',
  'water_milliliters_per_bird' : 'ml/ave',
  'water_history_load_error' : 'Não foi possível carregar o histórico de consumo de água',
};
